var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_10263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.182 43.75C53.4326 43.75 56.8913 40.2913 56.8913 36.0407C56.8913 31.79 53.4326 28.334 49.182 28.334C44.9313 28.334 41.4727 31.7927 41.4727 36.0433C41.4727 40.294 44.934 43.75 49.182 43.75ZM49.182 31.0007C51.9633 31.0007 54.2246 33.262 54.2246 36.0433C54.2246 38.8247 51.9633 41.086 49.182 41.086C46.4006 41.086 44.1393 38.8247 44.1393 36.0433C44.1393 33.262 46.4006 31.0007 49.182 31.0007Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0698 64.5496L49.1818 66.2269L50.2938 64.5496C50.6004 64.0856 54.9418 57.4936 58.5151 50.6243C58.9498 49.7843 59.3711 48.9443 59.7764 48.1069C61.7364 44.0483 63.2298 40.1389 63.2298 37.6056C63.2298 29.859 56.9284 23.5576 49.1818 23.5576C41.4351 23.5576 35.1338 29.859 35.1338 37.6056C35.1338 40.1629 36.6511 44.1203 38.6378 48.2163C39.0431 49.0536 39.4671 49.8936 39.9045 50.7336C43.4671 57.5629 47.7631 64.0883 48.0698 64.5496ZM37.8031 37.6029C37.8031 31.3256 42.9071 26.2216 49.1844 26.2216C55.4618 26.2216 60.5658 31.3283 60.5658 37.6029C60.5658 39.8323 59.0405 43.6483 57.0031 47.7283C56.5898 48.5603 56.1578 49.4003 55.7071 50.2429C53.5018 54.3896 50.9898 58.5363 49.1871 61.3656C47.3978 58.5603 44.9124 54.4616 42.7231 50.3523C42.2724 49.5123 41.8378 48.6723 41.4244 47.8403C39.3578 43.7149 37.8031 39.8536 37.8031 37.6029Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.181 51.8024L69.4584 59.9464C70.2904 59.6531 71.1491 59.4264 72.0371 59.2718L69.2744 49.3971L59.773 48.1064C59.3704 48.9438 58.9464 49.7838 58.5117 50.6238L67.181 51.8024Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6107 73.3412L36.272 66.6958L35.088 66.1038L33.552 66.7652L27.0747 69.5518L32.04 51.8025L39.9067 50.7332C39.4693 49.8932 39.048 49.0532 38.64 48.2158L29.944 49.3972L23 74.2105L35.0027 69.0425L49.6107 76.3198L59.448 71.4185C59.7093 70.1545 60.136 68.9545 60.6827 67.8238L49.6107 73.3412Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0102 52.957L33.5488 66.765L35.0848 66.1037L36.2715 66.6957L38.6342 53.4264L36.0102 52.957Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.584 53.4266L62.608 64.7786C63.2933 63.936 64.064 63.168 64.9067 62.488L63.208 52.96L60.584 53.4266Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.661 62.333C67.853 62.333 62.333 67.853 62.333 74.6663C62.333 81.4797 67.853 86.9997 74.6663 86.9997C81.4797 86.9997 86.9997 81.4797 86.9997 74.6663C86.9997 67.853 81.4796 62.333 74.661 62.333ZM82.2183 76.6663H76.661V82.2237C76.661 83.3277 75.765 84.2237 74.661 84.2237C73.5516 84.2237 72.661 83.3277 72.661 82.2237V76.6663H67.109C66.005 76.6663 65.109 75.7703 65.109 74.6663C65.109 73.5623 66.005 72.6663 67.109 72.6663H72.661V67.1143C72.661 66.0103 73.557 65.1143 74.661 65.1143C75.765 65.1143 76.661 66.0103 76.661 67.1143V72.6663H82.2183C83.3277 72.6663 84.2237 73.5623 84.2237 74.6663C84.2237 75.7703 83.3277 76.6663 82.2183 76.6663Z",
    fill: "#26BAEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_10263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/region.70487bceefbb664a0a06c55094585882.svg";
export { ForwardRef as ReactComponent };